export default "__VITE_ASSET__BLvFRwOE__"